<h4 class="font-semibold text-xl mt-2 mb-1 px-4 md:px-0">
  {{ '#WORKSHOP.DIALOGS.CLOSE_TASK.TITLE' | translate }}
</h4>
<p class="text-sm color-light px-4 md:px-0">
  {{ '#WORKSHOP.DIALOGS.CLOSE_TASK.INSTRUCTIONS' | translate }}
</p>

<div class="select-list px-4 md:px-0">
  <div
    class="select-list-item"
    (click)="select('approval')"
    [ngClass]="[selectedMethod === 'approval' ? 'selected' : '']"
  >
    {{ '#WORKSHOP.DIALOGS.CLOSE_TASK.APPROVAL' | translate }}
  </div>
  <div
    class="select-list-item"
    (click)="select('deliveryNote')"
    [ngClass]="[selectedMethod === 'deliveryNote' ? 'selected' : '']"
  >
    {{ '#WORKSHOP.DIALOGS.CLOSE_TASK.DELIVERY_NOTE' | translate }}
  </div>
  <div
    class="select-list-item"
    (click)="select('invoice')"
    [ngClass]="[selectedMethod === 'invoice' ? 'selected' : '']"
  >
    {{ '#WORKSHOP.DIALOGS.CLOSE_TASK.INVOICE' | translate }}
  </div>
</div>

<div class="actions flex flex-row flex-nowrap mt-4 w-full">
  <button
    class="soft-button h-14 w-full text-center secondary fill-force md:mr-1.5"
    (click)="close('cancel')"
  >
    {{ '#WORKSHOP.DIALOGS.ABORT' | translate }}
  </button>
  <button
    class="soft-button h-14 w-full primary fill-force text-center md:ml-1.5"
    (click)="continue()"
    [disabled]="(isSaving$ | async) || !canContinue"
  >
    <span>
      @if (isSaving$ | async) {
        <i class="fa-regular fa-spinner fa-spin"></i>
      }
      {{ '#WORKSHOP.DIALOGS.SUBMIT_CONTINUE' | translate }}
    </span>
  </button>
</div>
